function e(e){const a={};return Object.keys(e).forEach((r=>{a[r]=`${e[r]}`})),new URLSearchParams(a)}export{e as default};
